import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("mulywan_lang") || "en");

  useEffect(() => {
    localStorage.setItem("mulywan_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    const v = translations[lang]?.[key];
    return v !== undefined ? v : translations.en[key] ?? key;
  }, [lang]);

  // localized product field: prefers `${field}_hi` when in hindi
  const tp = useCallback((product, field) => {
    if (lang === "hi" && product[`${field}_hi`]) return product[`${field}_hi`];
    return product[field];
  }, [lang]);

  const thl = useCallback((term) => translations[lang]?.hl?.[term] || term, [lang]);
  const tcat = useCallback((cat) => translations[lang]?.cat?.[cat] || cat, [lang]);
  const tprice = useCallback((label) => {
    if (label && label.toLowerCase().includes("wholesale")) return t("price_wholesale");
    return t("price_best");
  }, [t]);

  const toggle = useCallback(() => setLang((l) => (l === "en" ? "hi" : "en")), []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, tp, thl, tcat, tprice }}>
      {children}
    </LanguageContext.Provider>
  );
};
